import React from 'react';
import { FadeIn } from './Shared';
import { XCircle } from 'lucide-react';
export const PainSection = () => {
  const pains = ['Madrugadas buscando métodos que se contradicen', 'Rutinas que funcionan un día y al siguiente no', 'Sin entender las ventanas de sueño ni las señales reales', 'Bebé que duerme en brazos pero no en la cuna', 'El mismo ciclo agotador, todas las semanas'];
  return <section className="py-6 md:py-10 px-4 bg-navy-900 mt-[0px] mb-[0px]" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <FadeIn data-id="element-177">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-6 text-center" data-id="element-178">
            ¿Cuántas madrugadas más <br className="hidden md:block" data-id="element-179" />
            <span className="text-gold-400 italic" data-id="element-180">vas a pasar así?</span>
          </h2>

          <div className="prose prose-invert mx-auto mb-8 text-gray-100 text-center" data-id="element-181">
            <p data-id="element-182">
              Amás a tu bebé. Pero nadie te dijo que ibas a pasar las noches
              caminando por el pasillo, buscando en Google a las 3 AM con los
              ojos entrecerrados, sin entender qué está pasando.
            </p>
            <p className="font-medium text-white mt-2" data-id="element-183">
              No es que sos mal padre o mala madre. Es que nadie te dio un
              sistema.
            </p>
          </div>

          <div className="bg-navy-800/50 border border-navy-700 rounded-2xl p-6 md:p-8 mb-8 shadow-xl" data-id="element-184">
            <ul className="space-y-4" data-id="element-185">
              {pains.map((pain, index) => <li key={index} className="flex items-start" data-id="element-186">
                  <XCircle className="w-6 h-6 text-red-400/80 mr-4 flex-shrink-0 mt-0.5" data-id="element-187" />
                  <span className="text-lg text-white" data-id="element-188">{pain}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-189">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-400" data-id="element-190">
              ¿Y si esta fuera la última madrugada que pasás así?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
};